import React, { useState } from 'react';
import { postData } from '../global/Globalapi'; // adjust path as needed
import { toast } from 'react-toastify';

const FetchPaymentDetails = () => {
  const [paymentId, setPaymentId] = useState('');
  const [paymentDetails, setPaymentDetails] = useState(null);

  const handleFetch = async () => {
    if (!paymentId) {
      toast.error("Please enter a payment ID");
      return;
    }

    try {
      const res = await postData('/get-payment', { payment_id: paymentId });
      console.log("details",res)
      if (res.success) {
        setPaymentDetails(res.payment);
        toast.success("Payment details fetched");
      } else {
        toast.error("Failed to fetch payment details");
      }
    } catch (err) {
      toast.error("Error fetching payment");
      console.error("Fetch error:", err);
    }
  };

  return (
    <div className="p-6 max-w-xl mx-auto bg-white shadow rounded-lg mt-10">
      <h2 className="text-xl font-bold mb-4">Fetch Razorpay Payment Details</h2>

      <input
        type="text"
        value={paymentId}
        onChange={(e) => setPaymentId(e.target.value)}
        placeholder="Enter Razorpay Payment ID"
        className="w-full px-4 py-2 border border-gray-300 rounded mb-4"
      />

      <button
        onClick={handleFetch}
        className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
      >
        Fetch Payment
      </button>

      {paymentDetails && (
        <div className="mt-6 bg-gray-100 p-4 rounded">
          <h3 className="font-semibold text-lg mb-2">Payment Info</h3>
          <pre className="text-sm overflow-x-auto">{JSON.stringify(paymentDetails, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default FetchPaymentDetails;
